import { mixins as m, colors as c } from 'hfty-styles'

const CARD_WIDTH = 400
const CARD_HEIGHT = 700

export const styles = {
  mainWrapper: {
    ...m.flex(),
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    opacity: 1,
    zIndex: 2,
    backgroundColor: 'rgba(0, 0, 0, 0.45)',
  },
  card: {
    width: CARD_WIDTH,
    maxHeight: CARD_HEIGHT,
    padding: '20px 65px 45px',
    backgroundColor: c.white(),
  },

  formHeading: {
    ...m.flex(),
    width: '100%',
    padding: '20px 0',

  },
  formHeadingTitle: {
    fontSize: 22,
    color: '#656565',
  },
  formHeadingSubtitle: {
    fontSize: 19,
    color: '#656565',
  },

  formMain: {
    ...m.flexColumn('flex-start'),
    width: '100%',
  },
  selectorsWrapper: {
    width: '100%',
    marginTop: 15,
  },
  formField: {
    width: '100%',
    marginBottom: 10,
  },
  formTextField: {
    width: '100%',
  },

  selectWrapper: {
    ...m.flexColumn('flex-start'),
    width: '100%',
    marginBottom: 25,
  },
  selectLabel: {
    fontSize: '0.75em',
    letterSpacing: '.56px',
    color: 'var(--mdc-theme-text-hint-on-light,rgba(0,0,0,.38))',
  },
  select: {
    width: '100%',
    height: 45,
    border: '1px solid rgba(0,0,0,.12)',
  },

  rememberWrapper: {
    ...m.flex(),
    position: 'relative',
    width: '100%',
    paddingBottom: 15,
  },
  hintWrapper: {
    position: 'absolute',
    top: -70,
    right: -145,
    maxWidth: 220,
    padding: 12,
    color: c.primary(),
    fontSize: 15,
    lineHeight: '24px',
    backgroundColor: '#fff',
    border: `1px solid ${c.primary()}`,
  },

  buttons: {
    ...m.flex('space-between'),
    width: '100%',
  },
  cardFooterButton: {
    minWidth: 190,
    height: 40,
    fontSize: 13,
    color: '#fff',
  },
}
